import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "flag",
  "use": "flag-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"flag\"><path d=\"M17.56 16.08H6.44A4.08 4.08 0 012.36 12V5.33a4.08 4.08 0 014.08-4.08h11.12a4.08 4.08 0 014.08 4.08V12a4.08 4.08 0 01-4.08 4.08zM6.44 2.75a2.59 2.59 0 00-2.58 2.58V12a2.59 2.59 0 002.58 2.58h11.12A2.59 2.59 0 0020.14 12V5.33a2.59 2.59 0 00-2.58-2.58H6.44z\" /><path d=\"M3.11 22.75a.76.76 0 01-.75-.75V8.67a.75.75 0 111.5 0V22a.75.75 0 01-.75.75z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol